export default class Report {
  constructor(API) {
    this.api = API;
  }

  async sessionResultsAnalysis(courseID, instructorID, from, to) {
    const req = await this.api.newBaseRequest('POST');
    req.path = req.path = '/reports/sessionResultsAnalysis';
    req.body = { filters: { courseID, instructorID, from, to } };
    return await req.exec();
  }
  async sessionResults(dateFrom, dateTo, courseIDs, from, isPreview) {
    const req = await this.api.newBaseRequest('POST');
    req.path = req.path = '/reports/sessionResults' + (isPreview ? '/preview' : '');
    req.body = { filters: { dateFrom, dateTo, courseIDs, from } };
    if (!isPreview) req.bodyType = 'JSON/BLOB';
    return await req.exec();
  }
  async sessionList(from, to, state, courseID, instructorID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = req.path = '/reports/sessionList';
    req.body = { filters: { state, courseID, instructorID, from, to } };
    return await req.exec();
  }
  async sessionCharges(sessionID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = req.path = '/reports/sessionCharges/' + sessionID;
    req.body = {};
    return await req.exec();
  }
  async sessionShippingManifest(sessionID, updateShippingInfo) {
    const req = await this.api.newBaseRequest('POST');
    req.path = req.path = '/reports/sessionShippingManifest/' + sessionID;
    req.body = { updateShippingInfo };
    req.bodyType = 'JSON/BLOB';
    return await req.exec();
  }
}
